<!--
 * @Author: ghy
 * @Date: 2023-07-19 13:11:48
 * @LastEditors: ghy
 * @LastEditTime: 2023-07-19 13:15:18
 * @Description: 
-->
<template>
  <div class="CusTitle">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: true,
    },
  },
};
</script>

<style lang="less" scoped>
.CusTitle {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #bd1a2d;
  line-height: 33px;
  padding: 12px 0;
  box-sizing: border-box;
  border-bottom: 5px solid #bd1a2d;
}
</style>


// WEBPACK FOOTER //
// src/components/CusTitle.vue